module.exports = __webpack_public_path__ + "static/img/bg-tr.3cbba5b2.png";